import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import tw from 'tailwind.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faListAlt, faMapMarkedAlt } from '@fortawesome/free-solid-svg-icons';

import InputAutocomplete from './InputAutocomplete';
import SearchFilters from './SearchFilters';

export default ({
  searchByAddress, onChangeFilter, filters, className, showingMap, toggleShowMap,
}) => {
  const [address, setAddress] = useState('');
  const [addressCoordinates, setAddressCoordinates] = useState();

  const onChange = (coordinates) => {
    setAddressCoordinates(coordinates);
  };

  const onInput = (_address) => {
    setAddress(_address);
  };

  useEffect(() => {
    if (addressCoordinates) {
      searchByAddress(addressCoordinates);
    }
  }, [addressCoordinates]);

  return (
    <Container className={className}>
      <Input
        address={address}
        setAddress={setAddress}
        onChange={onChange}
        onInput={onInput}
      />

      <ButtonOpenList onClick={toggleShowMap}>
        {showingMap ? (
          <>
            <FontAwesomeIcon icon={faListAlt} size="lg" />
            <span className="text">Lista</span>
          </>
        ) : (
          <>
            <FontAwesomeIcon icon={faMapMarkedAlt} size="lg" />
            <span className="text">Mapa</span>
          </>
        ) }
      </ButtonOpenList>

      <Filters onFilter={onChangeFilter} filters={filters} />
    </Container>
  );
};

const Container = styled.div`
  box-sizing: border-box;

  ${tw`
    flex justify-center items-center mx-2
    absolute top-0 right-0 left-0 z-10 p-0
    bg-white shadow-lg z-10 rounded-lg p-2 mt-2
  `};

  @media (min-width: 768px) {
    ${tw`
      mx-0 p-0 pl-6 pr-10 rounded-none mt-0
    `};
  }
`;

const ButtonOpenList = styled.div`
  border: 1px solid #F0F0F0;
  color: #000099;

  ${tw`
    rounded-full ml-2 px-4 py-2 text-sm
    flex items-center justify-center
  `}

  @media (min-width: 768px) {
    ${tw`
      hidden
    `};
  }

  .text {
    ${tw`ml-2`}
  }
`;

const Filters = styled(SearchFilters)`
  ${tw`
    hidden
  `};

  @media (min-width: 768px) {
    ${tw`
      flex flex-row
    `};
  }
`;

const Input = styled(InputAutocomplete)``;
